/**
 * Labstep
 *
 * @module screens/ExperimentWorkflow/Index
 * @desc Experiment index
 */

import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { withUiPersistent } from 'labstep-web/containers/UiPersistent';
import GridNewIndexEntityViewLoader from 'labstep-web/grid/NewIndex/components/EntityViewLoader';
import type { EntityView } from 'labstep-web/models/entity-view.model';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import ScreensExperimentWorkflowIndexGrid from 'labstep-web/screens/ExperimentWorkflow/Index/Grid';
import ExperimentWorkflowIndexTableTimeline from 'labstep-web/screens/ExperimentWorkflow/Index/TableTimeline';
import type React from 'react';
import type { IExperimentWorkflowIndexProps } from './types';

export const ExperimentWorkflowIndex: React.FC<
  IExperimentWorkflowIndexProps
> = ({ group, uiPersistent, authenticatedUserEntity }) => {
  const hasSignatureWorkflowPremiumFeature =
    authenticatedUserEntity.hasFeatureEnabled('signature_workflow');
  if (uiPersistent.experiment_workflow_view === 'grid') {
    return (
      <GridNewIndexEntityViewLoader
        group={group}
        context="experiment_workflow_index"
        entityName={ExperimentWorkflow.entityName}
        premiumFeatures={{
          signature_workflow: hasSignatureWorkflowPremiumFeature,
        }}
      >
        {({ entityView }: { entityView: EntityView }) => (
          <ScreensExperimentWorkflowIndexGrid
            entityView={entityView}
            group={group}
          />
        )}
      </GridNewIndexEntityViewLoader>
    );
  }

  return <ExperimentWorkflowIndexTableTimeline group={group} />;
};

export default withAuthenticatedUserEntity(
  withUiPersistent(ExperimentWorkflowIndex),
);
